import { useState } from 'react'

function SvgInstagram(props) {
  const [hover, setHover] = useState(false)
  return (
    <svg
      onMouseEnter={() => setHover(!hover)}
      onMouseLeave={() => setHover(!hover)}
      xmlns='http://www.w3.org/2000/svg'
      width={21}
      height={20}
      {...props}>
      <defs>
        <linearGradient
          id='instagram_svg__a'
          x1='0%'
          x2='50%'
          y1='100%'
          y2='0%'>
          <stop offset='0%' stopColor='#FFC593' />
          <stop offset='51.945%' stopColor='#BC7198' />
          <stop offset='100%' stopColor='#5A77FF' />
        </linearGradient>
      </defs>
      <path
        fill={hover ? 'url(#instagram_svg__a)' : 'white'}
        d='M143.32 1.802c2.67 0 2.987.01 4.042.059 2.71.123 3.976 1.409 4.099 4.099.048 1.054.057 1.37.057 4.04 0 2.672-.01 2.988-.057 4.042-.124 2.687-1.387 3.975-4.1 4.099-1.054.048-1.37.058-4.041.058-2.67 0-2.987-.01-4.04-.058-2.718-.124-3.977-1.416-4.1-4.1-.048-1.054-.058-1.37-.058-4.041 0-2.67.01-2.986.058-4.04.124-2.69 1.387-3.977 4.1-4.1 1.054-.048 1.37-.058 4.04-.058zm0-1.802c-2.716 0-3.056.012-4.123.06-3.631.167-5.65 2.182-5.816 5.817-.05 1.067-.061 1.407-.061 4.123s.012 3.057.06 4.123c.167 3.632 2.182 5.65 5.817 5.817 1.067.048 1.407.06 4.123.06s3.057-.012 4.123-.06c3.629-.167 5.652-2.182 5.816-5.817.05-1.066.061-1.407.061-4.123s-.012-3.056-.06-4.122c-.163-3.629-2.18-5.65-5.816-5.817C146.377.01 146.036 0 143.32 0zm0 4.865a5.135 5.135 0 100 10.27 5.135 5.135 0 000-10.27zm0 8.468a3.333 3.333 0 110-6.666 3.333 3.333 0 010 6.666zm5.338-9.87a1.2 1.2 0 100 2.4 1.2 1.2 0 000-2.4z'
        transform='translate(-133)'
      />
    </svg>
  )
}

export default SvgInstagram
